import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

export const ChipContainer = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: ${COLORS.bgSubtle};
  color: ${COLORS.textTertiary};
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.06px;
`
